
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/captable/[id]",
      function () {
        return require("private-next-pages/captable/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/captable/[id]"])
      });
    }
  